import React, { useState, ChangeEvent, useEffect, useRef, FormEvent } from "react";
import { Form, Button, InputGroup } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { TreeItem, UIManagerActionTypes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  folder: TreeItem;
  onCancel: () => void;
  handleAction: ActionHandlerFunction;
};

function CreateFolderRowComponent(props: AllProps) {
  const { folder, handleAction, onCancel } = props;
  const [name, setName] = useState<string>("");
  const on_cancel_ref = useRef(onCancel);
  on_cancel_ref.current = onCancel;

  // Description: Escape key to close the create folder row
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setName("");
        on_cancel_ref.current();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Description: Submit the new folder name — fires stub action on parent
  function submit() {
    const trimmed_name = name.trim();
    if (trimmed_name.length === 0) {
      handleCancel();
      return;
    }
    handleAction({ actionType: UIManagerActionTypes.TreeNodeAddChild, params: { folder, name: trimmed_name } });
    handleCancel();
  }

  // Description: Cancel and reset state
  function handleCancel() {
    setName("");
    onCancel();
  }

  return (
    <div className="create-folder-row" onClick={(e) => e.stopPropagation()}>
      <span className="folder-icon no-children">
        <Icon className="ficon-folder" />
      </span>
      <Form
        onSubmit={(e: FormEvent<HTMLFormElement>) => {
          e.preventDefault();
          submit();
        }} >
        <InputGroup size="sm">
          <Form.Control
            autoFocus
            type="text"
            placeholder="New Folder Name"
            aria-label="create new folder"
            value={name}
            maxLength={255}
            onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.currentTarget.value)}
          />
          {!!name && (
            <>
              <Button
                variant="icon"
                size="sm"
                className="text-muted p-1"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setName("")}
              >
                Clear
              </Button>
              <Button
                variant="icon"
                size="sm"
                onMouseDown={(e) => e.preventDefault()}
                onClick={submit}
              >
                <Icon className="ficon-check" />
              </Button>
            </>
          )}
        </InputGroup>
      </Form>
    </div>
  );
}

export default React.memo(CreateFolderRowComponent);
